import { makeAutoObservable, runInAction } from 'mobx';

import { getAppInfoList, getAppMetricData, getAppRmsData, getAppCDData, getAppResourceQuotaData } from '@/api';

class Favorite {
  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  current = 1;
  pageSize = 12;
  total = 0;
  totalList = [];
  favoriteList = [];
  favoriteLoading = false;

    setCurrent(page) {
        runInAction(() => {
            this.current = page;
        });
    }

    setPageSize(size) {
        runInAction(() => {
            this.pageSize = size;
        });

    }



  //获取用户信息
  async getAppInfoList({ pageNum = 1, pageSize = 12, searchKey = '', tagIds = [] }) {
    runInAction(() => {
      this.favoriteLoading = true;
    });

    let res;
    const params = {
      pageNum,
      pageSize,
      searchKey,
      tagIds,
      favorite: true
    };

    try {
      res = await getAppInfoList(params);
      if (res?.code === 200 && res?.data) {
        runInAction(() => {
          this.current = pageNum;
          this.pageSize = pageSize;
          this.total = res.data.length;
          this.totalList = res.data || [];
          this.favoriteList = this.totalList.slice((pageNum-1)*pageSize, pageNum*pageSize);
        });
          const idList = this.favoriteList.map(item => item.id);
          this.metricSync(idList);


      }
    } catch (err) {}

    runInAction(() => {
      this.favoriteLoading = false;
    });

    return res;
  }

    flip({ pageNum = 1, pageSize = 12 }) {

        this.favoriteList = this.totalList.slice((pageNum-1)*pageSize, pageNum*pageSize);
        const idList = this.favoriteList.map(item => item.id);
        this.metricSync(idList);
    }

    metricSync(params){

        getAppMetricData(params).then(response => {
            if (response?.data && response?.code === 200) {
                const map = new Map(response.data.map(item => [item.id, item]));
                runInAction(() => {
                    this.favoriteList.forEach(app => {
                        const item = map.get(app.id);
                        if (item) {
                            app.cpu = item.cpu;
                            app.memory = item.memory;
                        }
                    });
                })
            }
        })
        getAppRmsData(params).then(response => {
            if (response?.data && response?.code === 200) {
                const map = new Map(response.data.map(item => [item.id, item]));
                runInAction(() => {
                    this.favoriteList.forEach(app => {
                        const item = map.get(app.id);
                        if (item) {
                            app.pod = item.pod;
                            app.status = item.status;
                        }
                    });
                })
            }
        })
        getAppCDData(params).then(response => {
            if (response?.data && response?.code === 200) {
                const map = new Map(response.data.map(item => [item.id, item]));
                runInAction(() => {
                    this.favoriteList.forEach(app => {
                        const item = map.get(app.id);
                        if (item) {
                            app.healthy = item.healthy;
                            app.synced = item.synced;
                            app.isHealthy = item.isHealthy;
                        }
                    });
                })
            }
        })
        getAppResourceQuotaData(params).then(response => {
            if (response?.data && response?.code === 200) {
                const map = new Map(response.data.map(item => [item.id, item]));
                runInAction(() => {
                    this.favoriteList.forEach(app => {
                        const item = map.get(app.id);
                        if (item) {
                            app.cpuRequest = item.cpuRequest;
                            app.cpuLimit = item.cpuLimit;
                            app.memoryRequest = item.memoryRequest;
                            app.memoryLimit = item.memoryLimit;
                        }
                    });
                })
            }
        })

    }
}

export default new Favorite();
